export default __webpack_public_path__ + "static/media/audio_38_regadera_de_agua.6e8c752b.mp3";